"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var Tooltip_1 = tslib_1.__importDefault(require("../../../Tooltip"));
var LongTextToolTip = function (_a) {
    var children = _a.children;
    if (typeof children === 'string' && children.length > 32) {
        return ((0, jsx_runtime_1.jsx)(Tooltip_1.default, tslib_1.__assign({ placement: 'bottom', title: children }, { children: (0, jsx_runtime_1.jsx)("span", tslib_1.__assign({ className: 'hst-breadcrumb-text' }, { children: children.slice(0, 32) + ' ...' })) })));
    }
    return (0, jsx_runtime_1.jsx)("span", tslib_1.__assign({ className: 'hst-breadcrumb-text' }, { children: children }));
};
exports.default = React.memo(LongTextToolTip);
